import Modal from "../../common/Modal"
import { useAdmin } from "../../../context/admin"
import GeneralInput from "../../common/GeneralInput"
import { ChangeEvent, FormEvent } from "react"
import { AiFillCloseCircle } from "react-icons/ai"
import AdminService from "../../../services/admin.service"
import { useGlobal } from "../../../context/global"

export default function EditCar() {
    const { setIsLoading } = useGlobal()
    const { editCarData, setEditCarData } = useAdmin()

    function onChange(e: ChangeEvent<HTMLInputElement>) {
        const name = e.target.name
        const value = e.target.value
        setEditCarData(prevData => ({...prevData, [name]: value}))
    }

    async function onSubmit(e: FormEvent<HTMLFormElement>) {
            e.preventDefault()
            setIsLoading(true)
            try {
                if (!editCarData) return
                const data = {
                    id: editCarData.id,
                    brand: editCarData.brand || undefined,
                    model: editCarData.model || undefined,
                    license_plate: editCarData.license_plate || undefined,
                    year: editCarData.year || undefined,
                    seats: editCarData.seats || undefined,
                    extra_seats: editCarData.extra_seats || undefined,
                    owner: editCarData.owner || undefined,
                    rut_owner: editCarData.rut_owner || undefined,
                    phone_owner: editCarData.phone_owner || undefined,
                }
                await AdminService.editCar(data)
                window.location.reload()
            } catch (error) {
                console.log(error)
            } finally {
                setIsLoading(false)
            }
        }

    return (
        <Modal onSubmit={onSubmit}>
            <h1>Edit car</h1>
            <div className="input-container">
                <GeneralInput
                label="Brand"
                value={editCarData!.brand || ''}
                onChange={onChange}
                placeholder="Volkswagen"
                name="brand"
                style={{marginBottom: '20px'}}
                />
                <GeneralInput
                label="Model"
                value={editCarData!.model || ''}
                onChange={onChange}
                placeholder="Golf"
                name="model"
                style={{marginBottom: '20px'}}
                />
                <GeneralInput
                label="License plate"
                value={editCarData!.license_plate || ''}
                onChange={onChange}
                placeholder="ABC123"
                name="license_plate"
                style={{marginBottom: '20px'}}
                />
            </div>
            <div className="input-container">
                <GeneralInput
                label="Year"
                value={editCarData!.year || ''}
                onChange={onChange}
                type="number"
                placeholder="2020"
                name="year"
                style={{marginBottom: '20px'}}
                />
                <GeneralInput
                label="Seats"
                value={editCarData!.seats || ''}
                onChange={onChange}
                type="number"
                placeholder="5"
                name="seats"
                style={{marginBottom: '20px'}}
                />
                <GeneralInput
                label="Extra seats"
                value={editCarData!.extra_seats || ''}
                onChange={onChange}
                type="number"
                placeholder="2"
                name="extra_seats"
                style={{marginBottom: '20px'}}
                />
            </div>
            <div className="input-container">
                <GeneralInput
                label="Owner"
                value={editCarData!.owner || ''}
                onChange={onChange}
                placeholder="Jose Perez"
                name="owner"
                style={{marginBottom: '20px'}}
                />
                <GeneralInput
                label="RUT owner"
                value={editCarData!.rut_owner || ''}
                onChange={onChange}
                placeholder="12.345.678-9"
                name="rut_owner"
                style={{marginBottom: '20px'}}
                />
                <GeneralInput
                label="Phone owner"
                value={editCarData!.phone_owner || ''}
                onChange={onChange}
                placeholder="+56912345678"
                name="phone_owner"
                style={{marginBottom: '20px'}}
                />
            </div>
            <div className="actions">
                <button type="submit">Edit car</button>
            </div>
            <div className="close"
            onClick={() => setEditCarData(undefined)}
            >
                <AiFillCloseCircle/>
            </div>
        </Modal>
    )
}